import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Determines if the page is in embedded-view
 * by looking for a URL query param (`embedded`).
 */
function useIsEmbedded() {
  const router = useRouter();
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    setIsEmbedded(() => 'embedded' in router.query);
  }, [router.query]);

  return isEmbedded;
}

export default useIsEmbedded;
